import clsx from "clsx";
import { forwardRef } from "react";
import type { JSX } from "react/jsx-runtime";
import type { FooterRow } from "../types/footer.ts";

export type FooterTab = {
  id: string;
  name: string;
  rows: FooterRow[];
};

type Props = {
  tab: FooterTab;
  tabIndex: number;
  isActive: boolean;
  onSelectTab: (tabIndex: number) => void;
};

const FooterTabButton = forwardRef<HTMLButtonElement, Props>(
  ({ tab, tabIndex, isActive, onSelectTab }, ref): JSX.Element => {
    function handleKeyDown(
      event: React.KeyboardEvent<HTMLButtonElement>,
    ): void {
      if (event.key === "ArrowRight") {
        onSelectTab(tabIndex + 1);
      } else if (event.key === "ArrowLeft") {
        onSelectTab(tabIndex - 1);
      }
    }

    return (
      <button
        id={`tab-${tab.id}`}
        key={tab.id}
        role="tab"
        aria-selected={isActive}
        aria-controls={tab.id}
        tabIndex={isActive ? 0 : -1}
        onClick={(): void => onSelectTab(tabIndex)}
        className={clsx(
          "mb-[-1px] rounded-t-small border border-transparent bg-backgroundSubdued px-medium py-xsmall text-bodySmall font-regular hover:bg-utilityNonessential hover:text-onSurfaceSubdued hover:underline focus-visible:outline-offset-[-2px]",
          isActive
            ? "border border-utilitySubdued border-b-backgroundSubdued"
            : "border-b-utilitySubdued",
        )}
        onKeyDown={handleKeyDown}
        ref={ref}
      >
        {tab.name}
      </button>
    );
  },
);

export default FooterTabButton;
